import { useContext, useEffect, useState } from "react";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _opt_ from "@Elementos/Opciones";
import ModalInformacion from "@ModalInformacion/ModalInformacion";

import "./Opciones.css";

function Opciones() {
  return (
    <>
    <div className="opciones"></div>
    </>
  )
}
export default Opciones;